export default "__VITE_ASSET__C8j8XFTX__"